// extracted by mini-css-extract-plugin
export const form = "DefaultSubscribeForm-module--form--OImrf";
export const disclaimerText = "DefaultSubscribeForm-module--disclaimer-text--1VrRg";
export const bodyFooterButton = "DefaultSubscribeForm-module--body-footer-button--2J4lV";
export const extraFieldsContainer = "DefaultSubscribeForm-module--extra-fields-container--2w8Ke";
export const requiredFieldsLabel = "DefaultSubscribeForm-module--required-fields-label--1ELmI";